import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist();

export const sideBarOpen = atom({ key: 'sideBarOpen', default: true, effects_UNSTABLE: [persistAtom] });
